import { render, staticRenderFns } from "./df-page-home.vue?vue&type=template&id=2cb59596"
import script from "./df-page-home.ts?vue&type=script&lang=js&external"
export * from "./df-page-home.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports